import React, { FunctionComponent, memo, ReactElement } from 'react'
import Grid from '@sport1/react-elements/Grid'
import LibImage from '@sport1/react-elements/Image'
import BodyFont from '../../Theme/Fonts/Body'
import AbsoluteLayout from '../../Layouts/Absolute'

export type MissingComponentProps = {
    type: string
    text?: string
}

// eslint-disable-next-line @typescript-eslint/no-var-requires
const MISSING_IMAGE = require('../../assets/missingComponent/Error_Screen.jpg')

const MissingComponent: FunctionComponent<MissingComponentProps> = ({
    type,
    text,
}): ReactElement => (
    <AbsoluteLayout component={<LibImage src={MISSING_IMAGE} width="100%" aspectRatio={1.78} />}>
        <Grid center>
            <BodyFont color="pearl" textAlign="center">
                {text || `Das Element "${type}" ist noch nicht implementiert.`}
            </BodyFont>
        </Grid>
    </AbsoluteLayout>
)

export default memo(MissingComponent)
